import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { Description } from "../../Typography/Description.js";
import { Label } from "../../Typography/Label.js";
import { ErrorList } from "../ErrorList.js";
import { useClassNamePrefix } from "../../../auxiliary/useClassNamePrefix.js";
import { toEnumViewClass } from "../../../utils/toEnumViewClass.js";
import { toEnumClass } from "../../../utils/toEnumClass.js";
import { toThemeClass } from "../../../utils/toThemeClass.js";
import { Stack } from "../../Stack/Stack.js";
const FieldContainer = memo(
  ({
    children,
    className,
    description,
    direction = "vertical",
    errors,
    gap = "small",
    label,
    labelDescription,
    labelPosition,
    width = "column",
    required,
    size,
    useLabelElement = true,
    style
  }) => {
    const LabelElement = useLabelElement ? "label" : "div";
    const componentClassName = `${useClassNamePrefix()}field-container`;
    const isLabelInline = labelPosition === "labelInlineLeft" || labelPosition === "labelInlineRight";
    return /* @__PURE__ */ jsxs(
      "div",
      {
        style,
        className: classNames(
          `${componentClassName}`,
          toEnumViewClass(size),
          toEnumViewClass(labelPosition),
          toEnumClass("width-", width === "none" ? void 0 : width),
          errors?.length ? toThemeClass(null, "danger") : null,
          className
        ),
        children: [
          /* @__PURE__ */ jsxs(LabelElement, { className: `${componentClassName}-label`, children: [
            (label || labelDescription) && /* @__PURE__ */ jsxs("span", { className: `${componentClassName}-header`, children: [
              label && /* @__PURE__ */ jsxs(Label, { children: [
                label,
                /* @__PURE__ */ jsx("span", { className: `${componentClassName}-required-asterix ${toThemeClass("danger", "danger")}`, children: required && "*" })
              ] }),
              labelDescription && /* @__PURE__ */ jsx(Description, { children: labelDescription })
            ] }),
            (children || !isLabelInline && description) && /* @__PURE__ */ jsxs("div", { className: `${componentClassName}-body`, children: [
              children && /* @__PURE__ */ jsx(
                Stack,
                {
                  className: `${componentClassName}-body-content`,
                  direction,
                  gap,
                  children
                }
              ),
              !isLabelInline && description && /* @__PURE__ */ jsx("span", { className: `${componentClassName}-body-content-description`, children: description })
            ] })
          ] }),
          isLabelInline && description && /* @__PURE__ */ jsx("span", { className: `${componentClassName}-body-content-description`, children: description }),
          !!errors && errors.length > 0 && /* @__PURE__ */ jsx("div", { className: `${componentClassName}-errors`, children: /* @__PURE__ */ jsx(ErrorList, { errors }) })
        ]
      }
    );
  }
);
FieldContainer.displayName = "FieldContainer";
export {
  FieldContainer
};
//# sourceMappingURL=FieldContainer.js.map
